<template>
  <div class="tax_wrap">
    <header class="head-tax">
      <img
          @click="showRightKey=''"
          class="icon" src="https://static.rhkj.com/renhe_fe/other/362.png"/>
      <h3 @click="showRightKey=''">自然人电子税务局（扣款端）</h3>
      <img class="op1" src="https://static.rhkj.com/renhe_fe/other/363.png"/>
      <div class="grow"></div>
      <img class="op2" src="https://static.rhkj.com/renhe_fe/other/372.png"/>
    </header>

    <div class="sub-top">
      <div class="left-title">
        代扣代缴
        <div class="tri"></div>
      </div>
      <div class="right-nav">
        <div class="nav-item" @click="showRightKey=''">
          <el-icon><House /></el-icon>
          首页
        </div>

      </div>
    </div>
    <div class="content">
      <div class="left">
        <el-menu
            class="el-menu-vertical-demo"
            :default-active="activeKey"
        >

          <template v-for="item in menuList" :key="item.key">

            <el-menu-item v-if="item.show" :disabled="item.disabled" :key="item.key" :index="item.key"
                          @click="changeKey">
              <!-- <img :src="item.icon" alt=""> -->
              <!-- <i :class="`i-${item.icon}`" /> -->
              <Icon :icon="item.icon"/>
              <span>{{ item.title }}</span>
            </el-menu-item>
          </template>
        </el-menu>

        <div class="menu-bottom">
          <img
              style="width: 141px;"
              src="https://static.rhkj.com/renhe_fe/other/373.png"/>
        </div>
      </div>

      <div class="main-right">
        <div class="r_title">
          <span>税款所属月份</span>
          <el-select
              :model-value="1"
              style="width: 100px;margin-left: 10px;transform: scale(0.95);"
              disabled
          >
            <el-option
                v-for="s in [
                  { label: '2024-01', value: 1 },
                ]"
                :key="s.value"
                :label="s.label"
                :value="s.value"
            />
          </el-select>
        </div>

        <div class="box-ri-wrap">
          <div class="box-right">

            <div  v-if="!showRightKey">
              <div class="daily">
                <p class="type">
                  <span>常用功能</span>
                </p>
                <ul class="menu_list">
                  <template v-for="(item,index) in menuList" :key="index">
                    <li v-if="item.inCommonUse" @click="setActiveKey(item)">
                      <img style="width: 55px;height: 55px;" :src="item.newIcon"/>

                      <div class="info">
                        <p>{{ item.title }}</p>
                        <p>{{ item.desc }}</p>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>

              <div class="todo">
                <p class="type">
                        <span>
                            待处理事项
                            <el-text type="danger">(0)</el-text>
                        </span>
                </p>
                <div>
                  <el-empty description="暂无待处理事项"/>
                </div>
              </div>
            </div>

            <div class="other-comp" v-else>
              <component :is="showRightCopm"/>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script setup>
import {openBus} from '@/views/examCenter/tax/bus'
import {Icon} from "@iconify/vue";
import personCollection from './personCollection/index.vue';
import transferAdditional from './transferAdditional/index.vue';
import consolidatedIncome from './consolidatedIncome/index.vue';
import payOver from './PayOver/index.vue'

const menuList = ref([
  {
    title: '人员信息采集',
    key: 'PersonnelInformationCollection',
    img: 'https://a.chanjet.com/sn/static/individual/Content/images/icon_rycj.png',
    desc: "自然人基础信息登记，报送和公安系统身份验证",
    icon: "ic:sharp-person-add-alt",
    newIcon: 'https://static.rhkj.com/renhe_fe/other/366.png',
    inCommonUse: true,
    show: true,
    disabled: false,
  },
  {
    title: '专项附加扣除信息采集',
    key: 'TransferAdditionalDeductionInformationCollection',
    img: 'https://a.chanjet.com/sn/static/individual/Content/images/icon_zxfj.png',
    desc: "子女教育支出、住房租金支出等信息采集",
    icon: "solar:user-id-outline",
    newIcon: 'https://static.rhkj.com/renhe_fe/other/367.png',
    inCommonUse: true,
    show: true,
    disabled: false,
  },
  {
    title: '个人养老金扣除信息采集',
    key: '8',
    img: 'https://a.chanjet.com/sn/static/individual/Content/images/icon_zxfj.png',
    desc: "子女教育支出、住房租金支出等信息采集",
    icon: "solar:users-group-rounded-linear",
    inCommonUse: false,
    show: true,
    disabled: true,
  },
  {
    title: '综合所得申报',
    key: 'ConsolidatedIncomeDeclaration',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "solar:book-bookmark-broken",
    newIcon: 'https://static.rhkj.com/renhe_fe/other/368.png',
    inCommonUse: true,
    show: true,
    disabled: false,
  },
  {
    title: '分类所得申报',
    key: '1',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "利息股息红利、财产租赁、财产转让等月度申报",
    icon: "solar:bookmark-linear",
    newIcon: 'https://static.rhkj.com/renhe_fe/other/369.png',
    inCommonUse: true,
    show: true,
    disabled: true,
  },
  {
    title: '非居民所得申报',
    key: '2',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "solar:user-cross-bold",
    newIcon: 'https://static.rhkj.com/renhe_fe/other/370.png',
    inCommonUse: true,
    show: true,
    disabled: true,
  },
  {
    title: '限售股所得申报',
    key: '3',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "ic:baseline-developer-board-off",
    inCommonUse: false,
    show: true,
    disabled: true,
  },
  {
    title: '税款缴纳',
    key: '4',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "个人所得税款在线缴纳",
    icon: "ic:outline-line-axis",
    newIcon: 'https://static.rhkj.com/renhe_fe/other/371.png',
    inCommonUse: true,
    show: true,
    disabled: true,
  },
  {
    title: '优惠备案',
    key: '5',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "ic:baseline-diversity-1",
    inCommonUse: false,
    show: true,
    disabled: true,
  },
  {
    title: '查询统计',
    key: '6',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "ic:baseline-checklist-rtl",
    inCommonUse: false,
    show: true,
    disabled: true,
  },
  {
    title: '税款缴纳页面',
    key: '7',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "ic:outline-line-axis",
    inCommonUse: false,
    show: false,
    disabled: true,
  },
  {
    title: '系统设置',
    key: '9',
    img: "https://a.chanjet.com/sn/static/individual/Content/images/icon_zhsb.png",
    desc: "工资薪金、劳务报酬、稿酬、特许权使用费等月度申报",
    icon: "solar:settings-line-duotone",
    inCommonUse: false,
    show: true,
    disabled: true,
  },
])
const activeKey = ref('')
const setActiveKey = (item) => {
  if (!item.disabled) {
    showRightKey.value = item.key;
    activeKey.value = item.key;
    setCurrentComp(item.key)
  }
}
const showRightKey = ref('');
const showRightCopm = shallowRef(null)
const changeKey = (it) => {
  showRightKey.value = it.index;
  setCurrentComp(it.index)
}
const setCurrentComp = (key) => {
  switch (key) {
    case 'PersonnelInformationCollection':
      showRightCopm.value = personCollection
      break;
    case 'TransferAdditionalDeductionInformationCollection':
      showRightCopm.value = transferAdditional
      break;
    case 'ConsolidatedIncomeDeclaration':
      showRightCopm.value = consolidatedIncome // 综合所得申报
      break;
    case '7':
      showRightCopm.value = payOver
      break;
    default:
      break;
  }
}
openBus.on(val => {
  setCurrentComp(val.key)
})

const currentQa = inject('provideCurrentQa');

onMounted(() => {
  // 默认为工资薪金菜单

  if (currentQa.value.sonQueType == '52') { //全年奖金数据处理
    const f = menuList.value.find(f => f.key == 'TransferAdditionalDeductionInformationCollection')
    if (f) { // 禁用专项附加扣除信息采集菜单
      f.disabled = true
    }
  }
})
</script>

<style lang="scss" scoped>
.tax_wrap {
  width: 100%;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;

  .head-tax {
    height: 70px;
    background-color: #4285F4;
    display: flex;
    align-items: center;

    .icon {
      width: 59px;
      height: 62px;
      margin-left: 8px;
      cursor: pointer;
    }

    > h3 {
      font-size: 20px;
      line-height: 28px;
      color: #FFF;
      margin-left: 3px;
      cursor: pointer;
    }

    .op1 {
      width: 58px;
      height: 54px;
      margin-left: 7px;
    }

    .grow {
      flex-grow: 1;
    }

    .op2 {
      height: 33px;
      margin-right: 60px;
    }

    //background: url(https://static.rhkj.com/renhe_fe/other/tax/head.png);
    //background-size: cover;
  }

  .sub-top {
    display: flex;

    .left-title {
      width: 260px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      background-color: #ACBAC3;
      color: #FFFFFF;
      font-size: 16px;
      position: relative;
      .tri {
        position: absolute;
        z-index: 2;
        top: 29px;
        width: 0;
        height: 0;
        border-top: 16px solid #ACBAC3;
        border-left: 13px solid transparent;
        border-bottom: 16px solid transparent;
        border-right: 13px solid transparent;
      }
    }

    .right-nav {
      flex-grow: 1;
      background-color: #F2F2F2;
      display: flex;
      align-items: center;
      padding-left: 12px;
      box-sizing: border-box;
      .nav-item {
        color: #4285F4;
        cursor: pointer;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    justify-content: space-between;

    .left {
      height: 100%;
      background-color: #fff;
      width: 260px;
      padding-top: 10px;
      box-sizing:border-box;

      .el-menu-vertical-demo {
        height: calc(100vh - 200px);
        overflow-y: auto;
      }

      .menu-bottom {
        display: flex;
        margin-top: 20px;
        justify-content: center;
        padding: 0 0 20px 0;
      }

      :deep(.el-menu) {
        border-right: none;
        --el-menu-item-height: 46px;

        .el-menu-item {
          //border-bottom: 1px solid #e7e8ea;
          box-sizing: border-box;

          img {
            display: block;
            width: 18px;
            height: 18px;
            margin-right: 8px;
            box-sizing: border-box;
          }

          i {
            display: block;
            width: 18px;
            height: 18px;
            margin-right: 8px;
            box-sizing: border-box;
          }

          svg {
            display: block;
            width: 18px;
            height: 18px;
            margin-right: 8px;
            box-sizing: border-box;
          }
        }

        .el-menu-item.is-disabled {
          background: none !important;
          cursor: not-allowed;
          opacity: 1;
        }

        .el-menu-item.is-active {
          color: #fff;
          background-color: var(--el-menu-active-color);
        }
      }
    }

    .box-right {

      .type {
        height: 60px;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        & > span {
          height: 20px;
          border-left: 5px solid var(--el-color-primary);
          box-sizing: border-box;
          line-height: 20px;
          text-indent: 12px;
          font-weight: bold;
        }
      }

      .menu_list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        // border-left: 1px solid #eee;
        // border-top: 1px solid #eee;
        li {
          width: 32%;
          height: 120px;
          display: flex;
          align-items: center;
          padding: 30px;
          margin-bottom: 20px;
          box-sizing: border-box;
          // border-bottom: 1px solid #eee;
          // border-right: 1px solid #eee;
          border: 1px solid #eee;
          cursor: pointer;
          border-radius: 4px;

          .img {
            img {
              display: block;
              width: 68px;
              height: 68px;
            }
          }

          .icon {
            width: 58px;
            height: 58px;
            border-radius: 50%;
            overflow: hidden;
            background-color: var(--el-color-primary-light-9);
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
          }

          .info {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            p:nth-child(1) {
              margin-bottom: 16px;
              font-size: 15px;
            }

            P:nth-child(2) {
              color: #999;
              font-size: 13px;
            }
          }
        }
      }
    }

    .main-right {
      width: 0;
      flex-grow: 1;
      .r_title {
        display: flex;
        align-items: center;
        background-color: #FFFFFF;
        height: 40px;
        line-height: 40px;
        padding-left: 10px;
        :deep(.el-select__wrapper) {
          &.is-disabled {
            background-color: #FFFF;
          }
          .el-select__selected-item {
            color: #333333;
          }
        }
      }

      .box-ri-wrap {
        background-color: #F4F6F9;
        padding: 20px;
        .box-right {
          .daily {
            background-color: #FFFFFF;
            padding: 0px 20px;
          }
          .todo {
            margin-top: 20px;
            background-color: #FFFFFF;
            padding: 0px 20px;
          }

          .other-comp {
            background-color: #FFFFFF;
            padding: 20px 20px 0 20px;
          }
        }
      }
    }
  }
}
</style>
